import React from 'react'

function PaymentStepsSI() {
  return (
    <div id="stepper">
      <ul class="steps">
        <li class="complete">
          <span>Payment Mode</span>
        </li>
        <li class="">
          <span>Payment Complete</span>
        </li>
      <li class="">
        <span>Setup Autopay</span>
      </li>
    </ul>
  </div>
  )
}

export default PaymentStepsSI
